<template>
  <div v-if="review">
    <h4>Review Details</h4>

    <dl class="review-details-grid">
      <dt>Left By</dt>
      <dd v-if="review.user">
        {{ review.user.fullName }}
      </dd>
      <dd v-else>
        {{ review.clientName }} (created by admin)
      </dd>

      <dt>Review Score</dt>
      <dd><star-rating :rating="review.scoreAverage" :editable="false"></star-rating></dd>
    </dl>

    <h5>Review</h5>
    <p>{{ review.reviewDescription }}</p>

    <h5>Admin Response</h5>
    <template v-if="review.responseFrom || review.responseMessage">
      <dl  class="review-details-grid">
        <dt>Left By</dt>
        <dd>{{ review.responseFrom || 'N/A | No name provided' }}</dd>
      </dl>

      <p>
        {{ review.responseMessage || 'N/A | No response provided' }}
      </p>
    </template>
    <p v-else>
      No response has been given
    </p>

    <v-divider class="section-divider condensed"></v-divider>

    <dl class="review-details-grid">
      <template v-for="item in reviewItemsToDisplay">
        <dt :key="'title-' + item.key">{{ item.key | friendlyDisplayKeys }}</dt>
        <dd :key="'value-' + item.key">
          <star-rating v-if="isScoreField(item.key)"
            :rating="review[item.key]"
            :editable="false"
          ></star-rating>

          <template v-else>
            {{ review[item.key] | friendlyDisplayValue(item.key) }}
          </template>
        </dd>
      </template>
    </dl>
  </div>
</template>

<script>
export default {
  name: 'CondensedUserReviewDetails',
  props: {
    review: Object,
  },
  data: () => ({
    reviewItemsToDisplay: [
      { key: 'scoreOverall' },
      { key: 'scoreClarity' },
      { key: 'scoreGathering' },
      { key: 'scoreTimeliness' },
      { key: 'scoreResponsiveness' },
      { key: 'userExperienceTags' },
      { key: 'reasonForChoosingLender' },
      { key: 'anonymous' },
      { key: 'verified' },
    ],
  }),
  methods: {
    isScoreField (key) {
      const scoreFields = [
        'scoreOverall',
        'scoreClarity',
        'scoreGathering',
        'scoreTimeliness',
        'scoreResponsiveness',
      ]

      return scoreFields.includes(key)
    },
  },
}
</script>

<style lang="scss" scoped>
h4 {
  padding-bottom: 5px;
}

p {
  padding: 5px 10px;

  color: rgba(0, 0, 0, 0.7);
}

dl {
  display: grid;
  grid-gap: 5px 20px;
  padding: 10px;

  dt {
    font-weight: bold;
    min-width: 50px;
  }

  &.review-details-grid {
    grid-template-columns: auto 1fr;
  }
}

::v-deep {
  tr.v-data-table__expanded__content {
    td {
      padding-top: 10px;
      padding-bottom: 10px;
    }
  }
}
</style>
